export const en = {
  resourcesList: [
    {
      name: "Czech Vegetation Database",
      linkTo: "https://czechveg.github.io/",
      img: "resources-cnfd_en"
    },
    {
      name: "Vegetace ČR (monografie)",
      linkTo: "/vegetationCR",
      img: "resources-monography_en"
    },
    {
      name: "JUICE",
      linkTo: "/juice",
      img: "resources-juice"
    },
    {
      name: "Expertní systém",
      linkTo: "/expertSystem",
	  img: "resources-expertSystem_en"
    },
    {
      name: "Pladias",
      linkTo: "/pladias",
      img: "resources-pladias_en"
    },
	{
      name: "FloraVeg.EU",
      linkTo: "/floraveg",
      img: "resources-floraveg"
    },

    {
      name: "European Vegetation Archive",
      linkTo: "/eva",
      img: "resources-eva_en"
    },
	    {
      name: "Botanická fotogalerie",
      linkTo: "/botanicPhotogallery",
      img: "resources-photogallery_en"
    },
    {
      name: "Bibliografie vegetace ČR",
      linkTo: "/bibliography",
      img: "resources-bibliography_en"
    }
  ]
};

export const cz = {
    resourcesList: [
      {
        name: "Česká vegetační databáze",
        linkTo: "https://czechveg.github.io/",
        img: "resources-cnfd_cz"
      },
      {
        name: "Vegetace ČR (monografie)",
        linkTo: "/vegetationCR",
        img: "resources-monography_cz"
      },
      {
        name: "JUICE",
        linkTo: "/juice",
        img: "resources-juice"
      },
      {
        name: "Expertní systém",
        linkTo: "/expertSystem",
		img: "resources-expertSystem_cz"
      },
      {
        name: "Pladias",
        linkTo: "/pladias",
        img: "resources-pladias_cz"
      },
	  {
      name: "FloraVeg.EU",
      linkTo: "/floraveg",
      img: "resources-floraveg"
    },
     
      {
        name: "European Vegetation Archive",
        linkTo: "/eva",
        img: "resources-eva_cz"
      },
	   {
        name: "Botanická fotogalerie",
        linkTo: "/botanicPhotogallery",
        img: "resources-photogallery_cz"
      },
      {
        name: "Bibliografie vegetace ČR",
        linkTo: "/bibliography",
        img: "resources-bibliography_cz"
      }
    ]
  };